import { AnalyticsEvents } from '../firebase'

const SIGN_UP_URL = 'https://app.acesense.io/sign-up'

const plans = [
  {
    name: 'Free',
    description: 'Test AceSense on your own matches.',
    price: '€0',
    priceNote: 'No credit card required',
    features: [
      '3 analyses every month',
      'Complete coaching report',
      'Every analysis feature',
      'iOS and Android',
    ],
    action: 'Start free',
    analyticsLocation: 'pricing-free',
  },
  {
    name: 'Pro',
    description: 'For a weekly self-coaching loop.',
    price: '€19',
    priceNote: '€190 yearly · save 2 months',
    features: [
      'Unlimited analyses',
      'Everything in Free',
      'Unlimited report history',
      'Coach-share links + CSV export',
    ],
    action: 'Choose Pro',
    analyticsLocation: 'pricing-pro',
    featured: true,
  },
  {
    name: 'Team',
    description: 'For coaches and growing clubs.',
    price: '€49',
    priceNote: '€490 yearly · save 2 months',
    features: [
      '10 player seats',
      'Everything in Pro',
      'Coach dashboard',
      'Centralised billing',
    ],
    action: 'Choose Team',
    analyticsLocation: 'pricing-team',
  },
]

interface PricingTiersProps {
  showHeader?: boolean
}

/**
 * The three marketing pricing tiers (Free / Pro / Team). Single source of
 * truth for the tier numbers + feature bullets — rendered on both the
 * homepage (`src/App.tsx`) and the `/pricing` route (`ContentPage`). Markup
 * and classes are identical to the block that previously lived inline in
 * App.tsx, so the homepage renders byte-for-byte the same.
 */
export function PricingTiers({ showHeader = true }: PricingTiersProps) {
  const trackWebAppClick = (location: string) => {
    AnalyticsEvents.webAppClick(location)
  }
  const PlanHeading = showHeader ? 'h3' : 'h2'

  return (
    <section
      id="pricing"
      className="pricing section"
      aria-labelledby={showHeader ? 'pricing-heading' : undefined}
      aria-label={showHeader ? undefined : 'Pricing plans'}
    >
      <div className="container">
        {showHeader && (
          <div className="section-header text-center">
            <span className="section-tag">Pricing</span>
            <h2 id="pricing-heading">Simple, <span className="text-gradient">transparent pricing</span></h2>
          </div>
        )}
        <div className="pricing-grid">
          {plans.map((plan) => (
            <article
              key={plan.name}
              className={plan.featured ? 'pricing-card featured' : 'pricing-card'}
            >
              <div className="pricing-plan-header">
                <div>
                  <PlanHeading>{plan.name}</PlanHeading>
                  <p>{plan.description}</p>
                </div>
                {plan.featured && <span className="pricing-badge">Most popular</span>}
              </div>
              <div className="price">
                <span className="price-amount">{plan.price}</span>
                <span className="price-period">/ month</span>
              </div>
              <p className="price-note">{plan.priceNote}</p>
              <ul className="pricing-features">
                {plan.features.map((feature) => (
                  <li key={feature}><span className="check" aria-hidden="true">✓</span><span>{feature}</span></li>
                ))}
              </ul>
              <a
                href={SIGN_UP_URL}
                onClick={() => trackWebAppClick(plan.analyticsLocation)}
                className={`btn ${plan.featured ? 'btn-primary' : 'btn-secondary'} pricing-cta`}
              >
                {plan.action}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
